import { render, staticRenderFns } from "./TMenu.vue?vue&type=template&id=2407d84d&scoped=true&"
import script from "./TMenu.vue?vue&type=script&lang=js&"
export * from "./TMenu.vue?vue&type=script&lang=js&"
import style0 from "./TMenu.vue?vue&type=style&index=0&id=2407d84d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407d84d",
  null
  
)

/* custom blocks */
import block0 from "./TMenu.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports